import { DirectedEdge } from "../../graph/directed/directed-edge";
import { Grid } from "../../graph/lib/grid";
import { Node } from "../../graph/lib/node";

export class TreeEdge extends DirectedEdge{
  
  
    constructor(from: Node, to: Node) {
        super(from, to);
    }

    draw(ctx: CanvasRenderingContext2D, grid: Grid) {
        super.draw(ctx,grid)
    }

    getCenterFrom(grid: Grid) : [number,number]{
        return grid.getLowerMid(this.from.getRowIndex(), this.from.getColIndex());
    }
    
    getCenterTo(grid: Grid) : [number,number]{
        return grid.getUpperMid(this.to.getRowIndex(), this.to.getColIndex());        ;
    }
}
